const styles = (theme) => ({
  modalPaper: {
    maxWidth: 800,
    width: 720
  },
  centered: {
    justifyContent: 'center',
    alignItems: 'center'
  },
  inline: {
    display: 'inline-block'
  },
  mContent: {
    width: 720,
    minHeight: 290,
    position: 'relative',
    flexDirection: 'column',
    display: 'flex',
    backgroundColor: theme.colors.form__background_primary,
    padding: 50
  },
  closeButton: {
    position: 'absolute',
    top: 5,
    right: 5
  },
  loadingContainer: {
    textAlign: 'center'
  },
  errors: {
    color: theme.colors.error
  },
  title: {
    paddingBottom: 32,
    paddingTop: 24
  },
  arrow: {
    display: 'block'
  },
  priceInfo: {
    color: theme.colorPalette.green_20,
    marginBottom: 20
  },
  dateInfo: {
    fontSize: 20,
    marginBottom: 20
  },
  previewInfo: {
    marginBottom: 16
  },
  boldPrice: {
    fontWeight: 'bold',
    paddingLeft: 4
  },
  submit: {
    marginTop: 20
  },
  submitWarning: {
    marginTop: 20
  },
  orangeLink: {
    color: 'orange'
  },

  endDateVerbiage: {
    display: 'flex'
  },
  stateRuleAlert: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.palette.warning.light,
    padding: theme.spacing(3),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },
  coverageChangeContainer: {
    padding: theme.spacing(6)
  },
  noteContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: theme.spacing(4)
  },
  infoIcon: {
    marginRight: theme.spacing(2),
    marginTop: '2px',
    filter: `drop-shadow(0 0 0.5px ${theme.colorPalette.green_20})`
  },
  pipReqestedChangesListItem: {
    margin: theme.spacing(0.5, 2, 0.5, 0),
    display: 'block',
    fontSize: 14
  },
  changeItem: {
    margin: theme.spacing(0.5, 0),
    display: 'flex',
    alignItems: 'center'
  },
  oldValue: {
    backgroundColor: theme.colorPalette.red_50_op_10,
    color: theme.colorPalette.red_50,
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(0, 0.5)
  },
  newValue: {
    backgroundColor: theme.colorPalette.green_5_op_30,
    color: theme.colorPalette.green_30,
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.spacing(0.5),
    margin: theme.spacing(0, 0.5)
  },
  changeArrow: {
    margin: theme.spacing(0, 0.5),
    color: theme.colors.text_secondary
  },
  changeTag: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    marginRight: theme.spacing(1),
    fontSize: 12,
    flexShrink: 0,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.spacing(4),
    height: 32,
    minWidth: 80
  },
  changeTagChanged: {
    backgroundColor: '#fff3e0',
    color: '#ef6c00'
  },
  changeTagAdded: {
    backgroundColor: theme.colorPalette.green_5_op_30,
    color: theme.colorPalette.green_30
  },
  changeTagRemoved: {
    backgroundColor: theme.colorPalette.red_50_op_10,
    color: theme.colorPalette.red_50
  },
  changeTagAdditional: {
    backgroundColor: theme.colors.form__background_secondary,
    color: theme.colors.text_secondary
  },
  previewLoading: {
    justifyContent: 'center',
    paddingTop: theme.spacing(4)
  },
  icon: {
    marginBottom: theme.spacing(10)
  },
  clarionDoorContainer: {
    textAlign: 'right',
    margin: theme.spacing(4, 0)
  }
});

export default styles;
